export function getProgramDeadline(program) {
  const duration = program?.duration;
  if (!duration?.enabled || !duration.endDateTime) return null;
  const deadline = new Date(duration.endDateTime).getTime();
  return Number.isFinite(deadline) ? deadline : null;
}

export function hasProgramExpired(program, now = Date.now()) {
  const deadline = getProgramDeadline(program);
  return deadline !== null && now >= deadline;
}
